// extracted by mini-css-extract-plugin
export var btnSection = "ReplacementProductDetail_btnSection__BUhsV";
export var buttonWrapper = "ReplacementProductDetail_buttonWrapper__Bh-6-";
export var closeBtn = "ReplacementProductDetail_closeBtn__dhKKl";
export var container = "ReplacementProductDetail_container__KC4zN";
export var icon = "ReplacementProductDetail_icon__a58iu fa fa-chevron-left";
export var mobileContainer = "ReplacementProductDetail_mobileContainer__KsWRD";
export var modalWrapper = "ReplacementProductDetail_modalWrapper__nnjaQ";
export var productsWrapper = "ReplacementProductDetail_productsWrapper__BbLHk";
export var replacementDetailsModal = "ReplacementProductDetail_replacementDetailsModal__boXZf";